import Clouds from "./shaders/clouds";

export function initializeClouds(container) {
  const clouds = new Clouds(container);
  clouds.start();
}
